const aaa = [
 
    // 线上订单
    {
        path: "onlineOrderList",
        component: () => import("@/views/dingdan/order/onlineOrder/list.vue"),
        meta: { title: '订单', keepAlive: true},
    },
    {
        path: "onlineOrderSee",
        component: () => import("@/views/dingdan/order/onlineOrder/see.vue"),
        meta: { title: '订单' },
    },
    {
        path: "huotiDetail",
        component: () => import("@/views/dingdan/order/onlineOrder/huotiDetail.vue"),
        meta: { title: '订单' },
    },
    {
        path: "xuniDetail",
        component: () => import("@/views/dingdan/order/onlineOrder/xuniDetail.vue"),
        meta: { title: '订单' },
    },
    {
        path: "wenzhenDetail",
        component: () => import("@/views/dingdan/order/onlineOrder/wenzhenDetail.vue"),
        meta: { title: '订单' },
    },{
        path: "chufangDetail",
        component: () => import("@/views/dingdan/order/onlineOrder/chufangDetail.vue"),
        meta: { title: '订单' },
    },
    


    
]
export default aaa;